import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';

type Props = {
  disabled?: boolean;
  className?: string;
};

export default function DateYearInput({ disabled, className }: Props) {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 100 }, (_, i) => currentYear - i);

  const reset = () => setValue('');

  return (
    <div className="flex items-center gap-2 w-full relative">
      <div className="relative w-full">
        <input
          type="text"
          placeholder="yyyy"
          value={value}
          readOnly
          disabled={disabled}
          onClick={() => setOpen(!open)}
          className={className}
        />

        {open && (
          <div className="absolute z-10 mt-1 w-full max-h-40 overflow-auto bg-white border border-gray-200 rounded shadow">
            {years.map((year) => (
              <div
                key={year}
                className="px-3 py-2 hover:bg-pink-50 cursor-pointer text-sm"
                onClick={() => {
                  setValue(String(year));
                  setOpen(false);
                }}
              >
                {year}
              </div>
            ))}
          </div>
        )}
      </div>

      <button type="button" onClick={reset} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
}
